import React, { useState, useContext, useEffect } from "react";
import DataTableComponent from "react-data-table-component";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import IconButton from "@mui/material/IconButton";
import { Chip } from "@material-ui/core";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/Admin/AuthService";
import ProductService from "../../../../services/Admin/ProductService";
import WalletService from "../../../../services/Admin/WalletService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

import TxnDetailsDialog from "../../Transactions/TxnDetailsDialog";

const WalletStatementSection = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [isLoading, setIsLoading] = useState(false);

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [status, setStatus] = useState();
  const [category, setCategory] = useState();
  const [productId, setProductId] = useState();
  const [userId, setUserId] = useState();

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState();
  const [count, setCount] = useState();
  const [data, setData] = useState();

  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();

  useEffect(() => {
    fetchProducts();
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchText]);

  const [products, setProducts] = React.useState();

  const fetchProducts = async () => {
    try {
      const token = AuthService.getAccessToken();

      const data = await ProductService.fetchAll(token);

      const status1 = data.status;
      const message = data.message;

      if (status1 === "SUCCESS") {
        setProducts(data.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
  };

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await WalletService.transactions(
        token,
        fromDate,
        toDate,
        status,
        category,
        productId,
        props.searchText,
        searchText,
        page,
        size,
        true
      );

      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        setData(responseData.data.result);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    setIsLoading(false);
  };

  const columns = [
    {
      name: "User ID",
      cell: (row) => (
        <div>
          <span>{row.tbl_user.user_id}</span> <br />
          <small>{row.tbl_user.name}</small>
        </div>
      ),
    },
    {
      name: "Category/Date",
      cell: (row) => (
        <div>
          <span>{row.category}</span> <br />
          <small>{row.created_on}</small>
        </div>
      ),
    },
    {
      name: "Order ID",
      cell: (row) => (
        <div>
          <span>{row.order_id}</span>
          <br />
          <small>{row.partner_order_id}</small>
        </div>
      ),
    },
    {
      name: "Description",
      cell: (row) => (
        <div>
          <span>
            {row.product.sub_master_product
              ? row.product.sub_master_product.name
              : "NULL"}
            - {row.product ? row.product.name : "NULL"}
          </span>{" "}
          <br />
        </div>
      ),
    },
    {
      name: "Order Amount",
      cell: (row) => (
        <div>
          <Chip
            variant="outlined"
            size="small"
            color="primary"
            label={"₹" + row.order_amount.toFixed(2)}
          />
        </div>
      ),
    },
    {
      name: "Credit/Debit",
      cell: (row) => (
        <div>
          {(() => {
            if (row.txn_type === "CR") {
              return (
                <Chip
                  style={{ color: "green", borderColor: "green" }}
                  variant="outlined"
                  size="small"
                  color="primary"
                  label={"+" + row.amount.toFixed(2)}
                />
              );
            } else {
              return (
                <Chip
                  style={{ color: "red", borderColor: "red" }}
                  variant="outlined"
                  size="small"
                  color="primary"
                  label={"-" + row.amount.toFixed(2)}
                />
              );
            }
          })()}
        </div>
      ),
    },
    {
      name: "Balance",
      cell: (row) => (
        <div>
          <Chip
            variant="outlined"
            size="small"
            color="primary"
            label={"₹" + row.closing_bal.toFixed(2)}
          />
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <div style={{ textAlign: "center" }}>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <Chip
                  style={{ backgroundColor: "green" }}
                  size="small"
                  color="primary"
                  label="SUCCESS"
                />
              );
            } else if (row.status === "FAILED") {
              return (
                <Chip
                  style={{ backgroundColor: "red" }}
                  size="small"
                  color="primary"
                  label="FAILED"
                />
              );
            } else if (row.status === "PENDING") {
              return (
                <Chip
                  style={{ backgroundColor: "#FFCC00" }}
                  size="small"
                  color="primary"
                  label="PENDING"
                />
              );
            } else if (row.status === "REVERSAL") {
              return <Chip size="small" color="default" label="REVERSAL" />;
            } else if (row.status === "REFUND") {
              return <Chip size="small" color="default" label="REFUND" />;
            }
          })()}

          <br />
          <span
            style={{ textAlign: "center" }}
            onClick={() => {
              setSelectedData(row);
              setOpen(true);
            }}
          >
            View Details
          </span>
        </div>
      ),
    },
  ];
  return (
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-header">
                <h3 class="card-title">Wallet Statement</h3>
              </div>

              <div class="card-body">
                <div class="row mt-2">
                  <div class="col-md-12 mx-auto">
                    <form autoComplete="off">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="From Date"
                              onChange={(e) => {
                                setFromDate(e.target.value);
                              }}
                              defaultValue={fromDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="To Date"
                              onChange={(e) => {
                                setToDate(e.target.value);
                              }}
                              defaultValue={toDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                            >
                              <option value="">Select Status</option>
                              <option value="SUCCESS">SUCCESS</option>
                              <option value="PENDING">PENDING</option>
                              <option value="REFUND">FAILED</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setCategory(e.target.value);
                              }}
                            >
                              <option value="">Select Category</option>
                              <option value="TXN">TXN</option>
                              <option value="COMMISSION">COMMISSION</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            {products && (
                              <Autocomplete
                                options={products}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    label="Select Product"
                                  />
                                )}
                                onChange={(e, v) => {
                                  setProductId(v ? v.id : null);
                                }}
                              />
                            )}
                          </div>
                        </div>

                        {/* <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="User ID"
                              defaultValue={userId}
                              onChange={(e) => {
                                setUserId(e.target.value);
                              }}
                            />
                          </div>
                        </div> */}

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search Text"
                              onChange={(e) => {
                                setSearchText(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3" style={{ textAlign: "center" }}>
                          <button
                            type="button"
                            class="btn btn-primary mr-4"
                            onClick={() => {
                              fetchData();
                            }}
                          >
                            <i class="fa fa-search"></i> Search
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <DataTableComponent
                  noHeader={true}
                  columns={columns}
                  data={data}
                  progressPending={isLoading}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={count}
                  paginationPerPage={size}
                  onChangePage={(page) => {
                    setPage(page);
                    fetchData();
                  }}
                  paginationRowsPerPageOptions={[
                    10, 20, 50, 100, 200, 500, 1000,
                  ]}
                  onChangeRowsPerPage={(size) => {
                    setSize(size);
                    fetchData();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <TxnDetailsDialog setOpen={setOpen} open={open} fData={selectedData} />
    </section>
  );
};

export default WalletStatementSection;
